import { useAuthStore } from "@/store/auth.state";
import { Account } from "@vixi/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { api } from "@/apiInstance";
import { endpoints } from "@/endpoints";

const userInfoQueryOptions = () =>
  queryOptions({
    queryKey: ["userInfo"],
    queryFn: async ({ signal }) => {
      const data = (
        await api.get(endpoints.userInfo, {
          signal,
        })
      ).data as Account;

      return data;
    },
  });

export const useUserInfo = () => {
  const { setUserInfo } = useAuthStore();

  const query = useQuery(userInfoQueryOptions());
  const { data } = query;

  useEffect(() => {
    setUserInfo(data ?? null);
  }, [data]);

  return query;
};
